export const extras = {
  sources: {
    // IGN MVT ! Yeah !
    'plan.ign': {
      type: 'vector',
      maxzoom: 19,
      tiles: [
        'https://wxs.ign.fr/choisirgeoportail/geoportail/tms/1.0.0/PLAN.IGN/{z}/{x}/{y}.pbf'
      ],
      attribution: '© <a target="_blank" href="https://www.geoportail.gouv.fr/">Géoportail</a> IGN'
    },
  },
  layers: [{
    id: 'building-3d',
    type: 'fill-extrusion',
    minzoom: 17,
    source: 'plan.ign',
    'source-layer': 'bati_surf',
    filter: ['>', 'hauteur', 0],
    paint: {
      'fill-extrusion-color': 'hsl(39, 41%, 86%)',
      'fill-extrusion-opacity': 0.7,
      'fill-extrusion-base': 0,
      'fill-extrusion-height': [
        'get', 'hauteur'
      ]
    }
  }]
};

export const baseGraphs = {
  sources: {
    'basic_pedestrian': {
      id: 'basic_pedestrian',
      type: 'vector',
      maxzoom: 15,
      tiles: [
        'https://hitineraires.lorient-agglo.bzh/layers/lorient.basic_pedestrian/{z}/{x}/{y}.pbf'
      ],
      attribution: '© <a target="_blank" href="https://www.lorient-agglo.bzh/"> Lorient Agglomération</a>'
    },
    'walking_impaired_user' : {
      id: 'walking_impaired_user',
      type: 'vector',
      maxzoom: 15,
      tiles: [
        'https://hitineraires.lorient-agglo.bzh/layers/lorient.walking_impaired_user/{z}/{x}/{y}.pbf'
      ],
      attribution: '© <a target="_blank" href="https://www.lorient-agglo.bzh/"> Lorient Agglomération</a>'
    },
    'manual_wheelchair_user': {
      id: 'manual_wheelchair_user',
      type: 'vector',
      maxzoom: 15,
      tiles: [
        'https://hitineraires.lorient-agglo.bzh/layers/lorient.manual_wheelchair_user/{z}/{x}/{y}.pbf'
      ],
      attribution: '© <a target="_blank" href="https://www.lorient-agglo.bzh/"> Lorient Agglomération</a>'
    },
    'visually_impaired_user': {
      id: 'visually_impaired_user',
      type: 'vector',
      maxzoom: 15,
      tiles: [
        'https://hitineraires.lorient-agglo.bzh/layers/lorient.visually_impaired_user/{z}/{x}/{y}.pbf'
      ],
      attribution: '© <a target="_blank" href="https://www.lorient-agglo.bzh/"> Lorient Agglomération</a>'
    },
    'blind_user': {
      id: 'blind_user',
      type: 'vector',
      maxzoom: 15,
      tiles: [
        'https://hitineraires.lorient-agglo.bzh/layers/lorient.blind_user/{z}/{x}/{y}.pbf'
      ],
      attribution: '© <a target="_blank" href="https://www.lorient-agglo.bzh/"> Lorient Agglomération</a>'
    },
    'electric_wheelchair_user': {
      id: 'electric_wheelchair_user',
      type: 'vector',
      maxzoom: 15,
      tiles: [
        'https://hitineraires.lorient-agglo.bzh/layers/lorient.electric_wheelchair_user/{z}/{x}/{y}.pbf'
      ],
      attribution: '© <a target="_blank" href="https://www.lorient-agglo.bzh/"> Lorient Agglomération</a>'
    },
    'hearing_impaired_user': {
      id: 'hearing_impaired_user',
      type: 'vector',
      maxzoom: 15,
      tiles: [
        'https://hitineraires.lorient-agglo.bzh/layers/lorient.hearing_impaired_user/{z}/{x}/{y}.pbf'
      ],
      attribution: '© <a target="_blank" href="https://www.lorient-agglo.bzh/"> Lorient Agglomération</a>'
    },
    'deaf_user': {
      id: 'deaf_user',
      type: 'vector',
      maxzoom: 15,
      tiles: [
        'https://hitineraires.lorient-agglo.bzh/layers/lorient.deaf_user/{z}/{x}/{y}.pbf'
      ],
      attribution: '© <a target="_blank" href="https://www.lorient-agglo.bzh/"> Lorient Agglomération</a>'
    },
    'cognitively_impaired_user': {
      id: 'cognitively_impaired_user',
      type: 'vector',
      maxzoom: 15,
      tiles: [
        'https://hitineraires.lorient-agglo.bzh/layers/lorient.cognitively_impaired_user/{z}/{x}/{y}.pbf'
      ],
      attribution: '© <a target="_blank" href="https://www.lorient-agglo.bzh/"> Lorient Agglomération</a>'
    },
    'intellectually_disabled_user': {
      id: 'intellectually_disabled_user',
      type: 'vector',
      maxzoom: 15,
      tiles: [
        'https://hitineraires.lorient-agglo.bzh/layers/lorient.intellectually_disabled_user/{z}/{x}/{y}.pbf'
      ],
      attribution: '© <a target="_blank" href="https://www.lorient-agglo.bzh/"> Lorient Agglomération</a>'
    }
  },
  layers: [
    {
      'id': 'basic_pedestrian',
      'source': 'basic_pedestrian',
      'source-layer': 'lorient.basic_pedestrian',
      'type': 'line',
      'minzoom': 6,
      'layout': {
        'visibility': 'none'
      },
      'paint': {
        'line-color': '#6ba328',
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          10, 0.5,
          20, 4
        ]
      }
    },
    {
      'id': 'walking_impaired_user',
      'source': 'walking_impaired_user',
      'source-layer': 'lorient.walking_impaired_user',
      'type': 'line',
      'minzoom': 6,
      'layout': {
        'visibility': 'none',
        'line-sort-key': ['*', ['number', ['get', 'acc']], 4],
      },
      'paint': {
        'line-color': [
          'case',
          ['==', ['get', 'acc'], 1], '#22b32b',
          ['==', ['get', 'acc'], 2], '#d4901e',
          ['==', ['get', 'acc'], 3], '#FF8C00',
          ['==', ['get', 'acc'], 4], '#EE0125',
          ['==', ['get', 'acc'], 0], '#686868',
          '#222222'
        ],
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          10,
          ['case', 
            ['==', ['get', 'acc'], 0], 1,
            ['==', ['get', 'acc'], 1], 1,
            ['==', ['get', 'acc'], 2], 1, 
            0
          ],
          20,
          ['case',
            ['==', ['get', 'acc'], 0], 6,
            ['==', ['get', 'acc'], 1], 6,
            ['==', ['get', 'acc'], 2], 6,
            4
          ]
        ]
      }
    },
    {
      'id': 'manual_wheelchair_user',
      'source': 'manual_wheelchair_user',
      'source-layer': 'lorient.manual_wheelchair_user',
      'type': 'line',
      'minzoom': 6,
      'layout': {
        'visibility': 'none',
        'line-sort-key': ['*', ['number', ['get', 'acc']], 4],
      },
      'paint': {
        'line-color': [
          'case',
          ['==', ['get', 'acc'], 1], '#22b32b',
          ['==', ['get', 'acc'], 2], '#d4901e',
          ['==', ['get', 'acc'], 3], '#FF8C00',
          ['==', ['get', 'acc'], 4], '#EE0125',
          ['==', ['get', 'acc'], 0], '#686868',
          '#222222'
        ],
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          10,
          ['case', 
            ['==', ['get', 'acc'], 0], 1,
            ['==', ['get', 'acc'], 1], 1,
            ['==', ['get', 'acc'], 2], 1, 
            0
          ],
          20,
          ['case',
            ['==', ['get', 'acc'], 0], 6,
            ['==', ['get', 'acc'], 1], 6,
            ['==', ['get', 'acc'], 2], 6,
            4
          ]
        ]
      }
    },
    {
      'id': 'electric_wheelchair_user',
      'source': 'electric_wheelchair_user',
      'source-layer': 'lorient.electric_wheelchair_user',
      'type': 'line',
      'minzoom': 6,
      'layout': {
        'visibility': 'none',
        'line-sort-key': ['*', ['number', ['get', 'acc']], 4],
      },
      'paint': {
        'line-color': [
          'case',
          ['==', ['get', 'acc'], 1], '#22b32b',
          ['==', ['get', 'acc'], 2], '#d4901e',
          ['==', ['get', 'acc'], 3], '#FF8C00',
          ['==', ['get', 'acc'], 4], '#EE0125',
          ['==', ['get', 'acc'], 0], '#686868',
          '#222222'
        ],
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          10,
          ['case', 
            ['==', ['get', 'acc'], 0], 1,
            ['==', ['get', 'acc'], 1], 1,
            ['==', ['get', 'acc'], 2], 1, 
            0
          ],
          20,
          ['case',
            ['==', ['get', 'acc'], 0], 6,
            ['==', ['get', 'acc'], 1], 6,
            ['==', ['get', 'acc'], 2], 6,
            4
          ]
        ]
      }
    },
    {
      'id': 'intellectually_disabled_user',
      'source': 'intellectually_disabled_user',
      'source-layer': 'lorient.intellectually_disabled_user',
      'type': 'line',
      'minzoom': 6,
      'layout': {
        'visibility': 'none',
        'line-sort-key': ['*', ['number', ['get', 'acc']], 4],
      },
      'paint': {
        'line-color': [
          'case',
          ['==', ['get', 'acc'], 1], '#22b32b',
          ['==', ['get', 'acc'], 2], '#d4901e',
          ['==', ['get', 'acc'], 3], '#FF8C00',
          ['==', ['get', 'acc'], 4], '#EE0125',
          ['==', ['get', 'acc'], 0], '#686868',
          '#222222'
        ],
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          10,
          ['case', 
            ['==', ['get', 'acc'], 0], 1,
            ['==', ['get', 'acc'], 1], 1,
            ['==', ['get', 'acc'], 2], 1, 
            0
          ],
          20,
          ['case',
            ['==', ['get', 'acc'], 0], 6,
            ['==', ['get', 'acc'], 1], 6,
            ['==', ['get', 'acc'], 2], 6,
            4
          ]
        ]
      }
    },
    {
      'id': 'hearing_impaired_user',
      'source': 'hearing_impaired_user',
      'source-layer': 'lorient.hearing_impaired_user',
      'type': 'line',
      'minzoom': 6,
      'layout': {
        'visibility': 'none',
        'line-sort-key': ['*', ['number', ['get', 'acc']], 4],
      },
      'paint': {
        'line-color': [
          'case',
          ['==', ['get', 'acc'], 1], '#22b32b',
          ['==', ['get', 'acc'], 2], '#d4901e',
          ['==', ['get', 'acc'], 3], '#FF8C00',
          ['==', ['get', 'acc'], 4], '#EE0125',
          ['==', ['get', 'acc'], 0], '#686868',
          '#222222'
        ],
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          10,
          ['case', 
            ['==', ['get', 'acc'], 0], 1,
            ['==', ['get', 'acc'], 1], 1,
            ['==', ['get', 'acc'], 2], 1, 
            0
          ],
          20,
          ['case',
            ['==', ['get', 'acc'], 0], 6,
            ['==', ['get', 'acc'], 1], 6,
            ['==', ['get', 'acc'], 2], 6,
            4
          ]
        ]
      }
    },
    {
      'id': 'cognitively_impaired_user',
      'source': 'cognitively_impaired_user',
      'source-layer': 'lorient.cognitively_impaired_user',
      'type': 'line',
      'minzoom': 6,
      'layout': {
        'visibility': 'none',
        'line-sort-key': ['*', ['number', ['get', 'acc']], 4],
      },
      'paint': {
        'line-color': [
          'case',
          ['==', ['get', 'acc'], 1], '#22b32b',
          ['==', ['get', 'acc'], 2], '#d4901e',
          ['==', ['get', 'acc'], 3], '#FF8C00',
          ['==', ['get', 'acc'], 4], '#EE0125',
          ['==', ['get', 'acc'], 0], '#686868',
          '#222222'
        ],
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          10,
          ['case', 
            ['==', ['get', 'acc'], 0], 1,
            ['==', ['get', 'acc'], 1], 1,
            ['==', ['get', 'acc'], 2], 1, 
            0
          ],
          20,
          ['case',
            ['==', ['get', 'acc'], 0], 6,
            ['==', ['get', 'acc'], 1], 6,
            ['==', ['get', 'acc'], 2], 6,
            4
          ]
        ]
      }
    },
    {
      'id': 'deaf_user',
      'source': 'deaf_user',
      'source-layer': 'lorient.deaf_user',
      'type': 'line',
      'minzoom': 6,
      'layout': {
        'visibility': 'none',
        'line-sort-key': ['*', ['number', ['get', 'acc']], 4],
      },
      'paint': {
        'line-color': [
          'case',
          ['==', ['get', 'acc'], 1], '#22b32b',
          ['==', ['get', 'acc'], 2], '#d4901e',
          ['==', ['get', 'acc'], 3], '#FF8C00',
          ['==', ['get', 'acc'], 4], '#EE0125',
          ['==', ['get', 'acc'], 0], '#686868',
          '#222222'
        ],
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          10,
          ['case', 
            ['==', ['get', 'acc'], 0], 1,
            ['==', ['get', 'acc'], 1], 1,
            ['==', ['get', 'acc'], 2], 1, 
            0
          ],
          20,
          ['case',
            ['==', ['get', 'acc'], 0], 6,
            ['==', ['get', 'acc'], 1], 6,
            ['==', ['get', 'acc'], 2], 6,
            4
          ]
        ]
      }
    },
    {
      'id': 'visually_impaired_user',
      'source': 'visually_impaired_user',
      'source-layer': 'lorient.visually_impaired_user',
      'type': 'line',
      'minzoom': 6,
      'layout': {
        'visibility': 'none',
        'line-sort-key': ['*', ['number', ['get', 'acc']], 4],
      },
      'paint': {
        'line-color': [
          'case',
          ['==', ['get', 'acc'], 1], '#22b32b',
          ['==', ['get', 'acc'], 2], '#d4901e',
          ['==', ['get', 'acc'], 3], '#FF8C00',
          ['==', ['get', 'acc'], 4], '#EE0125',
          ['==', ['get', 'acc'], 0], '#686868',
          '#222222'
        ],
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          10,
          ['case', 
            ['==', ['get', 'acc'], 0], 1,
            ['==', ['get', 'acc'], 1], 1,
            ['==', ['get', 'acc'], 2], 1, 
            0
          ],
          20,
          ['case',
            ['==', ['get', 'acc'], 0], 6,
            ['==', ['get', 'acc'], 1], 6,
            ['==', ['get', 'acc'], 2], 6,
            4
          ]
        ]
      }
    },
    {
      'id': 'blind_user',
      'source': 'blind_user',
      'source-layer': 'lorient.blind_user',
      'type': 'line',
      'minzoom': 6,
      'layout': {
        'visibility': 'none',
        'line-sort-key': ['*', ['number', ['get', 'acc']], 4],
      },
      'paint': {
        'line-color': [
          'case',
          ['==', ['get', 'acc'], 1], '#22b32b',
          ['==', ['get', 'acc'], 2], '#d4901e',
          ['==', ['get', 'acc'], 3], '#FF8C00',
          ['==', ['get', 'acc'], 4], '#EE0125',
          ['==', ['get', 'acc'], 0], '#686868',
          '#222222'
        ],
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          10,
          ['case', 
            ['==', ['get', 'acc'], 0], 1,
            ['==', ['get', 'acc'], 1], 1,
            ['==', ['get', 'acc'], 2], 1, 
            0
          ],
          20,
          ['case',
            ['==', ['get', 'acc'], 0], 6,
            ['==', ['get', 'acc'], 1], 6,
            ['==', ['get', 'acc'], 2], 6,
            4
          ]
        ]
      }
    }
  ]
};

export const baseMaps = {
  version: 8,
  glyphs: 'https://api.maptiler.com/fonts/{fontstack}/{range}.pbf?key=k20fNAVQobo9djwCJvVl',
  sources: {
    'osm-tiles': {
      type: 'raster',
      tiles: [
        'https://api.maptiler.com/maps/10415bf4-696b-4d08-8eea-175ede02a50f/256/{z}/{x}/{y}.png?key=k20fNAVQobo9djwCJvVl'
      ],
      tileSize: 256,
      maxzoom: 19,
      attribution: '© <a target="_blank" href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    },
    'ortho-tiles': {
      type: 'raster',
      tiles: [
        'https://api.maptiler.com/maps/3684748f-10e1-4315-8a0a-8954d88a70c0/{z}/{x}/{y}.png?key=k20fNAVQobo9djwCJvVl'
      ],
      tileSize: 256,
      maxzoom: 19,
      attribution: '© <a target="_blank" href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    },
    ...baseGraphs.sources,
    ...extras.sources
  },
  layers: [{
    id: 'osm-tiles',
    type: 'raster',
    source: 'osm-tiles',
    interactive: true
  }, 
  {
    id: 'ortho-tiles',
    type: 'raster',
    source: 'ortho-tiles',
    interactive: true,
    layout: {
      // Make the layer not visible by default.
      'visibility': 'none'
    },
  },
  ...baseGraphs.layers,
  ...extras.layers
  ]
};
